/**
 * Sets CSS custom properties used by the secondary navigation.
 * Currently calculates the nav header height and stores it in `--header-height`.
 *
 * @param {HTMLElement} block The secondary navigation block element.
 * @param {HTMLElement} root  The element to receive the CSS custom property (e.g. document.documentElement).
 * @return {void}
 */
const setMainStyles = ( block, root ) => {

	const header = block.querySelector( '.b-secondary-navigation__nav' );
	const headerHeight = header?.offsetHeight;

	if ( headerHeight && headerHeight > 0 ) {

		root.style.setProperty( '--header-height', `${headerHeight}px` );

	}

}

/**
 * Attaches a debounced window resize listener that recalculates layout-related styles.
 *
 * @param {HTMLElement} block The secondary navigation block element.
 * @param {HTMLElement} root  The element to receive the CSS custom property (e.g. document.documentElement).
 * @return {void}
 */
const screenResize = ( block, root ) => {

	let resizeDebounceTimer;

	window.addEventListener( 'resize', () => {

		clearTimeout( resizeDebounceTimer );

		resizeDebounceTimer = setTimeout( () => {

			setMainStyles( block, root );

		}, 200 );


	}, { passive: true } );

}

/**
 * Toggles the mobile menu open/closed state.
 * Adds/removes active classes and locks/unlocks page scrolling.
 *
 * @param {HTMLElement} hamburgerMenu The hamburger toggle button/element.
 * @param {HTMLElement} mobileNav     The mobile menu wrapper element.
 * @param {HTMLElement} body          The document body element.
 * @return {void}
 */
const toggleMobileMenu = ( hamburgerMenu, mobileNav, body ) => {

	hamburgerMenu.classList.toggle( 'b-secondary-navigation__hamburger-menu--active' );
	mobileNav.classList.toggle( 'b-secondary-navigation__menu-wrapper--active' );
	body.classList.toggle( 'no-scroll' );

}

/**
 * Forces the mobile menu into the closed state.
 * Removes active classes and restores page scrolling.
 *
 * @param {HTMLElement} hamburgerMenu The hamburger toggle button/element.
 * @param {HTMLElement} mobileNav     The mobile menu wrapper element.
 * @param {HTMLElement} body          The document body element.
 * @return {void}
 */
const hideMobileMenu = ( hamburgerMenu, mobileNav, body ) => {

	hamburgerMenu.classList.remove( 'b-secondary-navigation__hamburger-menu--active' );
	mobileNav.classList.remove( 'b-secondary-navigation__menu-wrapper--active' );
	body.classList.remove( 'no-scroll' );

}

document.querySelectorAll( '.b-secondary-navigation' ).forEach( ( block ) => {

	const hamburgerMenu = block.querySelector( '.js-hamburger-menu' );
	const mobileNav = block.querySelector( '.b-secondary-navigation__menu-wrapper' );
	const body = document.querySelector( 'body' );
	const root = document.querySelector( 'html' );

	if ( !hamburgerMenu || !mobileNav || !body || !root ) {

		return;

	}

	const mediaQuery = '(max-width: 992px)';
	const mediaQueryList = window.matchMedia( mediaQuery );

	setMainStyles( block, root );
	screenResize( block, root );

	hamburgerMenu.addEventListener( 'click', () => {

		toggleMobileMenu( hamburgerMenu, mobileNav, body );

	} );

	mobileNav.addEventListener( 'click',  ( e ) => {

		// After click on mobile menu item
		if ( e.target.closest( '.menu-item ' ) && mediaQueryList.matches ) {

			hideMobileMenu( hamburgerMenu, mobileNav, body );

		}

	} );

	mediaQueryList.addEventListener( 'change', ( e ) => {

		// Hides mobile menu on desktop
		if ( !e.matches ) {

			hideMobileMenu( hamburgerMenu, mobileNav, body );

		}

	} );

} );
